<div class="flex flex-column gap-3 w-full">
	@for (store of stores; track store.slug || $index) {
		<app-store-card
			[store]="store"
			[code]="StoreDeliveryCodeEnum.Pickup"
			[isAvailable]="!!store.pickUpAvailable"
			[translations]="translations"
			(selected)="onSelectStore($event.store, $event.code)"
		></app-store-card>
	}
</div>
